import React from "react";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="relative bg-blueGray-200 pt-8 pb-6">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap text-left lg:text-left">
          <div className="w-full lg:w-6/12 px-4">
            <h4 className="text-3xl fonat-semibold text-blueGray-700">{t("footer.visitUs")}</h4>
            <h5 className="text-lg mt-0 mb-2 text-blueGray-600">
              {t("footer.openHours")}
            </h5>
            <div className="mt-6 lg:mb-0 mb-6">
              <p className="text-lg mt-0 mb-2 text-blueGray-600">
                {t("footer.addressLine1")} <br />
                {t("footer.addressLine2")} <br />
                {t("footer.addressLine3")} <br />
                {t("footer.phone")}{" "}
                <a href="tel:+919912671999" className="underline">
                  +91 9912671999
                </a>{" "}
                ,{" "}
                <a href="tel:+919542449889" className="underline">
                  +91 9542449889
                </a>
                <br />
              </p>
            </div>
          </div>
          <div className="w-full lg:w-6/12">
            <div className="flex flex-wrap items-top mb-6">
              <div className="w-full lg:w-4/12 px-4 ml-auto">
                <span className="block uppercase text-blueGray-800 text-sm font-bold mb-2">
                  {t("footer.usefulLinks")}
                </span>
                <ul className="list-unstyled">
                  <li>
                    <a
                      className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                      href="/about"
                    >
                      {t("footer.aboutUs")}
                    </a>
                  </li>
                  <li>
                    <a
                      className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                      href="/terms"
                    >
                      {t("footer.termsAndConditions")}
                    </a>
                  </li>
                  <li>
                    <a
                      className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                      href="privacy-policy"
                    >
                      {t("footer.privacyPolicy")}
                    </a>
                  </li>
                  <li>
                    <a
                      className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                      href="/locate"
                    >
                      {t("footer.contact")}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <hr className="my-6 border-blueGray-300" />
        <div className="flex flex-wrap items-center md:justify-between justify-center">
          <div className="w-full md:w-4/12 px-4 mx-auto text-center">
            <div className="text-sm text-blueGray-500 font-semibold py-1">
              {t("footer.copyright")} <span id="get-current-year">2024</span>
              <a href="/" className="text-blueGray-500 hover:text-gray-800">
                {" "}
                {t("brand")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
